import { Link } from "react-router-dom";
import { ExclamationTriangleIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import type { ReceiptListItem } from "../lib/receipts";
import { formatDate } from "../lib/format";
import { SignedAmount } from "./SignedAmount";

export function ReceiptCard({ receipt, navIds }: { receipt: ReceiptListItem; navIds?: string[] }) {
  return (
    <Link
      to={`/receipts/${receipt.id}`}
      state={navIds ? { navIds } : undefined}
      className="ios-card p-4 flex items-start gap-3 hover:shadow-cardHover transition active:scale-[0.99]"
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="text-[16px] font-semibold truncate">
            {receipt.vendor ?? <span className="text-ios-muted italic">Unbekannt</span>}
          </h3>
          {/* Signed-Amount-Konvention 2026-06-05: positiver totalAmount = Ausgabe (rot),
              negativer = Einnahme/Gutschrift (blau). Listen folgen damit der gleichen
              Farb-Konvention wie Beleg-Detail + Σ-Buckets. */}
          <SignedAmount
            value={receipt.totalAmount}
            currency={receipt.currency}
            className="text-[16px] font-semibold shrink-0"
          />
        </div>
        <div className="flex items-center gap-2 mt-1 text-[13px] text-ios-muted">
          <span>{formatDate(receipt.receiptDate)}</span>
          {/* S3: Abzeichen der Verwendungsart entfernt — die Steuer-Achse ist jetzt die Buchungsart je Position. */}
          {receipt.reviewedAt ? (
            <>
              <span>·</span>
              <span className="inline-flex items-center gap-1 text-ios-green">
                <CheckCircleIcon className="w-3.5 h-3.5" />
                geprüft
              </span>
            </>
          ) : receipt.needsReview ? (
            <>
              <span>·</span>
              <span className="inline-flex items-center gap-1 text-ios-orange">
                <ExclamationTriangleIcon className="w-3.5 h-3.5" />
                Prüfen
              </span>
            </>
          ) : null}
        </div>
      </div>
    </Link>
  );
}
